import TableCell from '@material-ui/core/TableCell';
import styles from '../../Customers/CustomersGrid/styles';
import React from 'react';

const getNoDataCellComponent = (icon, type) => ({ tableRow, children }) => {
  return (<TableCell colSpan={children.length} style={styles.noDataRow}>
    {/*<PersonIcon style={styles.noData}/>*/}
    {icon}
    <div style={styles.noDataText}>No {type} are available</div>
  </TableCell>);
};

export default getNoDataCellComponent;



// WEBPACK FOOTER //
// ./src/components/Common/NoDataCellComponent/index.js